<!-- Sección para filtros -->
<form class="col s12 padding-all-0" apply="theme" *ngIf="(config[1] && config[3]) || config[2]">
  <!-- Seleccionar cantidad de resgistros a mostrar por página -->
  <div class="input-field col s10 offset-s1 m6 l6 padding-left-0" *ngIf="config[1] && config[3]">
    <select [id]="'selectDataTable'+keyTable" #lengthTable (change)="reziseTable(lengthTable.value)">
      <option *ngFor="let item of list;let f = first" [value]="item" [selected]="f">{{item}}</option>
      <option value="all">Todo</option>
    </select>
    <label>Cantidad</label>
  </div>
  <!-- Buscar registros por texto -->
  <div class="input-field col s10 m6 l6 padding-right-0" *ngIf="config[2]">
    <i class="material-icons prefix pointer">search</i>
    <input #searchTable (keyup)="searchInTable(searchTable.value)" [id]="'searchDataTable'+keyTable" type="text">
    <label [for]="'searchDataTable'+keyTable">Buscar</label>
  </div>
</form>
<form class="col s12 padding-all-0" apply="theme" *ngIf="config[0]">
  <div class="table-options center-all border-theme border-left border-top border-right" apply="theme">
    <span>Ajustes</span>
    <i data-position="right" data-tooltip="Ver/Ocultar Filtros"
      class="tooltipped datatable-tooltip material-icons z-depth-1" apply="theme" (click)="activateTable($event)"
      *ngIf="variableConfig ? (!(variableConfig[1] && variableConfig[2] && variableConfig[3])) : (!(config[1] && config[2] && config[3]))">apps</i>
    <i data-position="right" data-tooltip="Ver/Ocultar Columnas" [attr.data-target]="'hiddenList'+keyTable"
      class="tooltipped datatable-tooltip material-icons z-depth-1 dropdown-trigger datatable-dropdown" apply="theme"
      *ngIf="hiddenGroups">visibility</i>
    <!-- <i data-position="right" data-tooltip="Ordenar" class="tooltipped datatable-tooltip material-icons z-depth-1"
      apply="theme">format_list_numbered</i> -->
  </div>
</form>
<ul [id]="'hiddenList'+keyTable" class='dropdown-content hiddenList' apply="theme" color="background"
  *ngIf="hiddenGroups">
  <ng-container *ngFor="let item of hiddenGroups;index as i">
    <li apply="theme" background="section" mouse-action="background-section-hover"
      class="mouse-action-theme-waves waves-effect border-all" style="display: block;">
      <ng-container
        *ngTemplateOutlet="hiddenListTemplate;context:{ value: i, text: ('Grupo '+(i+1)), event: 0, group: i };">
      </ng-container>
    </li>
    <ng-container *ngFor="let list of item">
      <li apply="theme" background="section" mouse-action="background-section-hover"
        class="mouse-action-theme-waves waves-effect" style="display: block;">
        <ng-container
          *ngTemplateOutlet="hiddenListTemplate;context:{ value: list, text: headers[0][list], event: 1, group: i };">
        </ng-container>
      </li>
    </ng-container>
  </ng-container>
</ul>
<!-- Select Multiple Template -->
<ng-template #hiddenListTemplate let-value="value" let-text="text" let-event="event" let-group="group">
  <form apply="theme">
    <label>
      <input [class]="'hiddenCheckbox group-'+group" type="checkbox" [value]="value"
        [checked]="event === 1 ? ((hideElements || []).includes(value) ? false : true) : false"
        (change)="checkSelection($event.target, event, group)" />
      <span [ngClass]="{ 'bld': event === 0 }">{{text}}</span>
    </label>
  </form>
</ng-template>
<!-- Sección para la tabla -->
<form apply="theme" class="col s12 padding-all-0 datatable-form" [id]="'datatable-form'+keyTable">
  <table [ngClass]="{'no-theme': currentTheme?.tagStyle == 'no-theme'}" [class]="classes" apply="theme">
    <!-- Cabecera de la tabla -->
    <thead>
      <tr *ngFor="let item of headers;let f = first;let i = index">
        <!-- Cabecera para la columna de selección de fila -->
        <th [class]="hClasses?.th" *ngIf="getValue">
          <a class="btn-flat auto-height padding-all-0" style="line-height: inherit;font-size:inherit;">
            <i class="material-icons icon-static-height" style="font-size:17px" color="theme"
              apply="theme">touch_app</i>
          </a>
        </th>
        <!-- Primera Cabecera (Cabecera principal) -->
        <ng-container *ngIf="f">
          <ng-container *ngFor="let list of item; let j = index;let ll = last">
            <th [class]="hClasses?.th" [attr.colspan]="colspan[0][i][j]" *ngIf="!hideTitles?.includes(j)"
              [ngClass]="[thClasses && thClasses[i] && thClasses[i][j.toString()] ? (thClasses[i][j.toString()]) : '',headerFixed ? 'th-fixed' : '']">
              <!-- Formato para cuando se tendrá tooltip -->
              <ng-container *ngIf="tooltip && tooltips[0][i][j]">
                <a class="tooltip-hover btn-flat auto-height padding-all-0"
                  style="line-height: inherit;text-transform: inherit;position:absolute;left:1%;top:calc(50% - 11px);">
                  <i class="material-icons fnt-15-i" color="theme" apply="theme"
                    (mouseover)="prettyTooltip.setTooltip(list, tooltips[0][i][j].text, (tooltips[0][i][j].direction ? tooltips[0][i][j].direction : 'bottom'), $event.target)"
                    (mouseout)="prettyTooltip.setTooltip()">{{tooltips[0][i][j].icon ? tooltips[0][i][j].icon : 'not_listed_location'}}</i>
                </a>
              </ng-container>
              <ng-container>
                <p class="margin-all-0" [ngClass]="{'padding-left-15': tooltip && tooltips[0][i][j]}">{{list}}</p>
              </ng-container>
            </th>
          </ng-container>
        </ng-container>
        <!-- Demás cabeceras (Cabeceras secundarias) -->
        <ng-container *ngIf="!f">
          <ng-container *ngFor="let list of item; let j = index;">
            <td [class]="hClasses?.td" [attr.colspan]="colspan[0][i][j]" *ngIf="!hideTitles?.includes(j)">
              <ng-container *ngIf="tooltip && tooltips[0][i] && tooltips[0][i][j]">
                <a class="tooltip-hover btn-flat auto-height padding-all-0"
                  style="line-height: inherit;text-transform: inherit;position:absolute;left:1%;top:calc(50% - 11px);">
                  <i class="material-icons fnt-15-i scale-lightness" color="background" apply="theme"
                    (mouseover)="prettyTooltip.setTooltip(list, tooltips[0][i][j].text, (tooltips[0][i][j].direction ? tooltips[0][i][j].direction : 'bottom'), $event.target)"
                    (mouseout)="prettyTooltip.setTooltip()">{{tooltips[0][i][j].icon ? tooltips[0][i][j].icon : 'not_listed_location'}}</i>
                </a>
              </ng-container>
              <p class="margin-all-0" [ngClass]="{'padding-left-15': tooltip && tooltips[0][i] && tooltips[0][i][j]}">
                {{list}}</p>
            </td>
          </ng-container>
        </ng-container>
      </tr>
    </thead>
    <!-- cuerpo de la tabla -->
    <tbody [id]="'responsiveBody'+keyTable" (mousewheel)="eventScroll($event)">
      <tr *ngFor="let item of tableBody;let i = index; trackBy: trackLoop"
        [ngClass]="{'bld': trBoldStyle && trBoldStyle[i],'border-bottom-important': trBorderStyle && trBorderStyle[i]}">
        <!-- columna de selección de fila -->
        <td *ngIf="getValue" colspan="1" [class]="bClasses?.td">
          <label style="display:inline-block;vertical-align:middle;"><input [checked]="i == 0 && autocheck"
              (change)="sendItem(item)" (click)="sendItem(null)" class="with-gap" name="send" type="radio" /><span
              class="without-content center-all"></span></label>
        </td>
        <!-- fila completa -->
        <ng-container *ngFor="let list of item | keys;let j = index; trackBy: trackLoop">
          <ng-container *ngIf="!replaceHighlight || (replaceHighlight && !replaceHighlight[j]?.toString())">
            <td [attr.colspan]="colspan[1] != [] ? colspan[1][j] : 1" *ngIf="!hideElements?.includes(j)"
              [ngClass]="[tdClasses && tdClasses[j.toString()] ? (tdClasses[j.toString()]) : '', (highlight && highlight[j]) ? (highlight[j] | setFill:item:list) : '']"
              [innerHTML]="(bodyCallbacks && bodyCallbacks[j.toString()] ? ([bodyCallbacks[j.toString()], item, item[list], i, list] | setValue:'callback') : item[list]) | sanitizeHtml"
              [class]="bClasses?.td">
            </td>
          </ng-container>
          <!-- columna de fila que se reemplaza por simbolo de acuerdo al valor -->
          <ng-container *ngIf="replaceHighlight && replaceHighlight[j]?.toString()">
            <td [attr.colspan]="colspan[1] != [] ? colspan[1][j] : 1" [class]="bClasses?.td"
              [ngClass]="[replaceHighlight[j]?.toString() ? 'bld' : '', replaceHighlight[j]?.toString() ? (item[list] ? (((item[list]).split('%')[0]) | localStringToNumber:'percentage' | getAbsolutePercentage:'color':['color-danger-important','color-success-important']:[replaceHighlight[j]]) : '') : '']">
              <a style="font-size:inherit;line-height: inherit;font-weight: inherit;color:inherit;">
                <i class="material-icons fnt-15-i" style="color:inherit;vertical-align:middle;font-weight: inherit;">
                  {{replaceHighlight[j]?.toString() ? (item[list] ? (((item[list]).split('%')[0]) | localStringToNumber:'percentage' | getAbsolutePercentage:'symbol':['arrow_downward','arrow_upward']:[replaceHighlight[j]]) : '') : ''}}
                </i>
              </a>
            </td>
          </ng-container>
        </ng-container>
      </tr>
      <!-- cuerpo cuando se recibe un array vacío -->
      <tr *ngIf="tableBody.length == 0">
        <td *ngIf="getValue" colspan="1"></td>
        <td [class]="bClasses?.td" [attr.colspan]="tLength">No se encontraron resultados</td>
      </tr>
    </tbody>
    <!-- Pie de página de la tabla -->
    <tfoot [ngClass]="{'hide-on-med-and-down': responsive}">
      <tr *ngFor="let item of footers;let i = index; trackBy: trackLoop">
        <td [class]="fClasses?.td" *ngFor="let list of item; let j = index; trackBy: trackLoop;"
          [attr.colspan]="colspan[2][i][j]">
          <!-- cuando tiene tooltip -->
          <ng-container *ngIf="tooltip && tooltips && tooltips[1] && tooltips[1][i] && tooltips[1][i][j]">
            <a class="tooltip-hover btn-flat auto-height padding-all-0"
              style="line-height: inherit;text-transform: inherit;position:absolute;left:1%;top:calc(50% - 11px);">
              <i class="material-icons fnt-15-i scale-lightness" color="background" apply="theme"
                (mouseover)="prettyTooltip.setTooltip(list, tooltips[1][i][j].text, (tooltips[1][i][j].direction ? tooltips[1][i][j].direction : 'bottom'), $event.target)"
                (mouseout)="prettyTooltip.setTooltip()">{{tooltips[1][i][j].icon ? tooltips[1][i][j].icon : 'not_listed_location'}}</i>
            </a>
          </ng-container>
          <!-- valor por recibido -->
          <p class="margin-all-0"
            [ngClass]="{'padding-left-15': tooltip && tooltips && tooltips[1] && tooltips[1][i] && tooltips[1][i][j]}">
            {{list}}</p>
        </td>
      </tr>
    </tfoot>
  </table>
</form>
<!-- Paginador de la tabla -->
<ng-template #notArrow>
  <div style="border-radius:3px;" class="col s2 margin-top-5 margin-bottom-5 center-all padding-all-0" apply="theme"
    background="section">
    <i class="material-icons disabled fnt-35">stop</i>
  </div>
</ng-template>
<div class="col s12 padding-all-0 margin-bottom-10" style="padding-right: 1.6px !important;"
  *ngIf="config[3] && pags.length > 1">
  <div class="row margin-all-0">
    <!-- Flecha izquierda para devolverse 1 -->
    <ng-container *ngIf="currentPage > 1; else notArrow">
      <div class="col s3 m2 padding-all-0 margin-top-5 margin-bottom-5 center-all" apply="theme" background="section">
        <i class="material-icons scale-lightness fnt-35 waves-effect" apply="theme" color="background"
          mouse-action="theme-waves" (click)="refreshTable(1);" style="border-radius:3px;">first_page</i>
        <i class="material-icons scale-lightness fnt-35 waves-effect" apply="theme" color="background"
          mouse-action="theme-waves" (click)="refreshTable(currentPage - 1);"
          style="border-radius:3px;">navigate_before</i>
      </div>
    </ng-container>
    <div class="col s6 m8 padding-all-0">
      <app-select2 [type]="'single'" [element]="pags.length" [keys]="['pag']" [isNumeric]="true"
        (sendValues)="$event.length > 0 ? refreshTable($event[0]) : null" [value]="currentPage">
      </app-select2>
    </div>
    <!-- Flecha derecha para aumentar 1 -->
    <ng-container *ngIf="currentPage < pags.length; else notArrow">
      <div apply="theme" background="section" class="col s3 m2 padding-all-0 margin-top-5 margin-bottom-5 center-all">
        <i class="material-icons scale-lightness fnt-35 waves-effect" apply="theme" color="background"
          mouse-action="theme-waves" (click)="refreshTable(currentPage + 1);"
          style="border-radius:3px;">navigate_next</i>
        <i class="material-icons scale-lightness fnt-35 waves-effect" apply="theme" color="background"
          mouse-action="theme-waves" (click)="refreshTable(pags.length);" style="border-radius:3px;">last_page</i>
      </div>
    </ng-container>
  </div>
</div>
<ng-container *ngIf="filterOptions">
  <!-- Modal para descargar información -->
  <div [id]="'modalForDownloadTable'+keyTable" class="modal modal-datatable modal-fixed-footer" apply="theme"
    background="section" style="border-right: 1px solid transparent;max-height:85%;">
    <div class="modal-content pretty-scrollbar padding-right-20 padding-left-20" apply="theme" background="section">
      <div class="row margin-all-0">
        <!-- titulo -->
        <div class="col s12 padding-all-0">
          <h6 class="title margin-top-0 margin-bottom-5 left-align padding-bottom-5 border-bottom" apply="theme"
            color="body">Opciones</h6>
        </div>
        <!-- Sección para los filtros -->
        <form [formGroup]="filterOptions" class="col s12 padding-all-0" apply="theme">
          <div class="row margin-all-0">
            <div class="input-field col s12 margin-bottom-0 padding-left-0">
              <select [id]="'downloadDataTable'+keyTable" formControlName="index">
                <ng-container *ngFor="let item of files;let i = index;">
                  <option [value]="i" style="text-transform: capitalize;">{{item.type}}</option>
                </ng-container>
              </select>
              <label style="left: 0;">Tipo de archivo</label>
            </div>
            <p>
              <label>
                <input type="checkbox" checked formControlName="filters" />
                <span>Aplicar Filtros <small>(Buscador, Paginador)</small></span>
              </label>
            </p>
          </div>
        </form>
      </div>
    </div>
    <!-- Opciones del modal (descargar, cerrar) -->
    <div class="modal-footer border-top" apply="theme" background="section">
      <a class="waves-effect padding-right-5 padding-left-5 btn-flat" mouse-action="success-waves" apply="theme"
        color="success" (click)="downloadFile()">Descargar</a>
      <a (click)="closeModal()" class="waves-effect padding-right-5 padding-left-5 btn-flat color-danger-important"
        mouse-action="danger-waves" apply="theme" color="body">Cancelar</a>
    </div>
  </div>
</ng-container>